// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* TAG STATUS */\n/* VIEW */\n.dashboard-container[data-v-97783298] {\n  width: 100%;\n  height: 100%;\n  padding: 167px 30px 15px;\n}\n@media (min-width: 769px) {\n.dashboard-container[data-v-97783298] {\n    padding-top: 76px;\n}\n}\n@media (min-width: 1176px) {\n.dashboard-container[data-v-97783298] {\n    grid-template-columns: 49% 49%;\n}\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
